import { ProductContainerVariant } from '@faire/web-api--source/com/faire/logging/ProductContainerVariant';
import { ProductSurfaceContainer } from '@faire/web-api--source/com/faire/logging/ProductSurfaceContainer';

export namespace IBrandPageSearchSuggestionsRequest {
  /**
   * Return an instance of IBrandPageSearchSuggestionsRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IBrandPageSearchSuggestionsRequest>
  ): IBrandPageSearchSuggestionsRequest =>
    ({
      ...(partial ?? {}),
    }) as IBrandPageSearchSuggestionsRequest;
}

export interface IBrandPageSearchSuggestionsRequest {
  /**
   * @protobufOption (.faire.common.tokenType) = BRAND
   */
  brand_token: string | undefined;
  query: string | undefined;
  request_id: string | undefined;
  /**
   * The surface container where the products are displayed
   */
  product_surface_container: keyof typeof ProductSurfaceContainer | undefined;
  /**
   * The variant of the surface container where the products are displayed
   */
  product_container_variant: keyof typeof ProductContainerVariant | undefined;
}
